
export default function Services() {
  const services = [
    {
      icon: 'ri-line-chart-line',
      title: 'Corporate Strategy Consulting',
      description: 'Develop comprehensive business strategies that align with your organizational goals, market positioning, and long-term vision. Our expert consultants analyze market trends, competitive landscapes, and internal capabilities to create actionable strategic roadmaps that drive measurable business growth and sustainable competitive advantages.',
      features: ['Strategic Planning', 'Market Analysis', 'Growth Strategy', 'Performance Optimization']
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Tax Optimization Services',
      description: 'Maximize your financial efficiency through intelligent tax planning and optimization strategies. Our specialized tax consultants provide comprehensive solutions for corporate tax structuring, international tax compliance, transfer pricing strategies, and regulatory adherence to minimize tax liabilities while ensuring full compliance with local and international tax regulations.',
      features: ['Tax Planning', 'Compliance Management', 'International Tax', 'Risk Mitigation']
    },
    {
      icon: 'ri-global-line',
      title: 'International Business Setup',
      description: 'Navigate the complexities of global expansion with our comprehensive international business establishment services. We provide end-to-end support for market entry strategies, legal entity formation, regulatory compliance, cross-border operations, and local market adaptation to ensure successful international business ventures and seamless global operations.',
      features: ['Market Entry', 'Legal Formation', 'Regulatory Compliance', 'Global Operations']
    },
    {
      icon: 'ri-server-line',
      title: 'IT Network Management',
      description: 'Ensure robust, secure, and efficient IT infrastructure with our comprehensive network management solutions. Our technical experts deliver enterprise-level network design, implementation, monitoring, security management, cloud integration, and ongoing maintenance to optimize your technology infrastructure and support business continuity.',
      features: ['Network Design', 'Security Management', 'Cloud Integration', '24/7 Monitoring']
    },
    {
      icon: 'ri-team-line',
      title: 'English-Speaking Staff Provision',
      description: 'Access highly qualified English-speaking professionals to support your international business operations and communication needs. We provide skilled personnel for various business functions including customer service, technical support, business development, and administrative roles, ensuring seamless communication in global business environments.',
      features: ['Talent Sourcing', 'Skill Assessment', 'Cultural Fit', 'Ongoing Support']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'IT & Business Consulting',
      description: 'Transform your business through strategic IT consulting and innovative business solutions. Our consultants combine deep technical expertise with business acumen to deliver digital transformation strategies, process optimization, technology roadmaps, and custom solutions that align IT capabilities with business objectives for maximum operational efficiency.',
      features: ['Digital Transformation', 'Process Optimization', 'Technology Strategy', 'Innovation Consulting']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Business Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Auralis Consulting offers a full spectrum of professional services designed to address your most critical business challenges and opportunities
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 group"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                <i className={`${service.icon} text-3xl text-blue-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <div className="space-y-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    <span className="text-sm font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
